<template>
  <Button icon="md-download" :loading="loading">
    <span v-if="!loading">导出</span>
    <span v-else>导出...</span>
  </Button>
</template>
<script>
import { saveFile } from '@/util'
export default {
  components: {},
  props:{
    requestKey:{
      type: String
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {},
  created() {},

  methods: {
    handleExport(search) {
      if(this.loading){
        return
      }else{
        this.loading = true
      }
      this.$request[this.requestKey](search).then(resp => {
        this.loading = false
        saveFile(resp)
      })
    },
  }
}

</script>
